import { Box } from "@design-system/Layout/Box";
import { FlexRow } from "@design-system/Layout/Flex";
import { ClassValue, cn } from "@design-system/Utilities";
import { type FC, type PropsWithChildren, type ReactNode } from "react";

import {
    FieldWrapper,
    WrapperProps,
} from "@design-system/Inputs/Textfield/FieldWrapper";

type DropdownFieldWrapperProps = WrapperProps & {
    middleClassName?: ClassValue;
    leadingElement?: ReactNode;
    trailingElement?: ReactNode;
};

export const DropdownFieldWrapper: FC<
    PropsWithChildren<DropdownFieldWrapperProps>
> = ({
    children,
    outerClassName,
    className,
    leadingElement,
    trailingElement,
    placeholderUp,
    ...props
}) => {
    return (
        <FlexRow
            className={cn(
                "flex-1",
                "min-h-[54px]",
                "group px-2 gap-2 rounded-lg border border-tertiary focus-within:border-primary",
                props.success && "border-[2px] !border-green",
                props.disabled && "bg-transparent",
                props.error && "border-[2px] !border-danger",
                outerClassName,
                className,
                props.disabled
                    ? "cursor-not-allowed bg-neutral-25"
                    : "bg-white",
            )}
            minW="full"
            alignItems="stretch"
        >
            <Box className="grid place-items-center">{leadingElement}</Box>
            <FieldWrapper
                {...props}
                outerClassName={cn(
                    "!border-none min-w-0 flex-1",
                    "text-left",
                    props.middleClassName,
                )}
                innerClassName={cn("!border-none px-0")}
                placeholderUp={placeholderUp}
            >
                {children}
            </FieldWrapper>

            <Box className="grid place-items-center">{trailingElement}</Box>
        </FlexRow>
    );
};
